import {
  faDownload,
  faEye,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

import Download_offcanvas from "../../../../../../../common/common_offcanvas/download_offcanvas/Download_offcanvas";
import Delete_offcanvas from "../../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";
import ScopeOfTheLaboratory_view_offcanvas from "../scopeOfTheLaboratory_view_offcanvas/ScopeOfTheLaboratory_view_offcanvas";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

function ScopeOfTheLaboratory_table() {
  const [view, setView] = useState(false);
  const [showDownload, setDownload] = useState(false);
  const [showDelete, setDelete] = useState(false);

  /* ================= TABLE DATA ================= */
  const data = [
    {
      srNo: "01",
      disciplineGroup: "Chemical - Solid Fuels",
      materialTested: "Coal",
      testPerformed: "Gross Calorific Value (GCV)",
      testMethod: "IS 1350 (Part 2)",
    },
    {
      srNo: "02",
      disciplineGroup: "Chemical - Solid Fuels",
      materialTested: "Coal",
      testPerformed:
        "Moisture (Moisture By Oven Drying (108 ± 2°C 1%))",
      testMethod: "IS 1350 (Part 1)",
    },
    {
      srNo: "03",
      disciplineGroup: "Chemical - Solid Fuels",
      materialTested: "Coal",
      testPerformed: "Volatile Matter",
      testMethod: "IS 1350 (Part 2)",
    },
    {
      srNo: "04",
      disciplineGroup: "Chemical - Solid Fuels",
      materialTested: "Coal",
      testPerformed: "Ash",
      testMethod: "IS 1350 (Part 1)",
    },
  ];

  /* ================= DELETE HANDLER ================= */
  const handleDelete = () => {
    console.log("Record deleted");
    setDelete(false);
  };
   const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Discipline / Group</th>
                  <th>Material Or Products Tested</th>
                  <th>
                    Component, Parameter Or Characteristic Tested /
                    Specific Test Performed / Tests Or Type Of Tests
                    Performed
                  </th>
                  <th>
                    Test Method Specification against which tests are
                    performed & / or the techniques / equipment used
                  </th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.srNo}</td>
                    <td>{row.disciplineGroup}</td>
                    <td>{row.materialTested}</td>
                    <td>{row.testPerformed}</td>
                    <td>{row.testMethod}</td>

                    <td>
                      <div className="action_icons">
                        <FontAwesomeIcon
                          icon={faEye}
                          onClick={() => setView(true)}
                        />
                        <FontAwesomeIcon
                          icon={faDownload}
                          onClick={() => setDownload(true)}
                        />
                        <FontAwesomeIcon
                          icon={faTrashCan}
                          onClick={() => setDelete(true)}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
      </section>

      {/* ================= VIEW ================= */}
      <ScopeOfTheLaboratory_view_offcanvas
        show={view}
        handleClose={() => setView(false)}
      />

      {/* ================= DOWNLOAD ================= */}
      <Download_offcanvas
        show={showDownload}
        handleClose={() => setDownload(false)}
        offcanvasHeading="Download Scope Of The Laboratory"
        massageText={"Scope Of The Laboratory"}
      />

      {/* ================= DELETE ================= */}
      <Delete_offcanvas
        show={showDelete}
        handleClose={() => setDelete(false)}
        handleDelete={handleDelete}
        offcanvasHeading="Delete Scope Of The Laboratory"
        massageText={"Scope Of The Laboratory"}
      />
    </>
  );
}

export default ScopeOfTheLaboratory_table;
